export default "__VITE_ASSET__Wr9GptNV__"